import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import RewardRow from "./RewardRow";
import "../../../../../../styles/ambassadorChallenge/rewardDistribution.scss";
import axios from "axios";
import { isAuth } from "../../../../../auth/ProtectedRoute";
import { useAmbassadorChallengeContext } from "../../../../../../contexts/AmbassadorChallengeContext";


const RewardDistribution: React.FC = () => {

  const {items, reward, fetchReward} = useAmbassadorChallengeContext();

  useEffect(() => {
    fetchReward();
  }, []);

   const [sending, setSending] = useState(false);

  const distributeBulkReward = async (challenge_id: number | undefined) => {
    try {
      setSending(true);
      const response = await axios.post(
        `${process.env.REACT_APP_HOST_API}ambassador/bulk-distribute-rewards`,
        {
          challenge_id: challenge_id,
        },
        {
          headers: {
            Authorization: `Bearer ${isAuth()}`,
          },
        }
      );

      if (response.status === 200) {
        swal({
          title: "Success!",
          text: response.data.message,
          icon: "success",
        });

        fetchReward();
      }
    } catch (error: any) {
      if (error.response) {
        console.error("API Error:", error.response.data);
      } else {
        console.error("Network Error:", error.message);
      }
      throw error;
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="rd-card">
      <header className="rd-header">
        <div>
          <h3>Reward Distribution</h3>
          <p className="subtitle">
            Manage and distribute rewards to challenge winners
          </p>
        </div>

        <button className="bulk-reward-btn"
        onClick={()=>{
          distributeBulkReward(reward?.data?.challenge.id)
        }}
        disabled={sending}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_11208_70595)">
              <path
                d="M8.33594 11.6667L17.5026 2.5"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.5018 2.5L12.0851 17.5C12.0485 17.5798 11.9898 17.6474 11.916 17.6948C11.8421 17.7422 11.7562 17.7674 11.6684 17.7674C11.5807 17.7674 11.4948 17.7422 11.4209 17.6948C11.347 17.6474 11.2883 17.5798 11.2518 17.5L8.3351 11.6667L2.50177 8.75C2.42198 8.71344 2.35437 8.65474 2.30697 8.58088C2.25957 8.50701 2.23438 8.4211 2.23438 8.33333C2.23437 8.24557 2.25957 8.15965 2.30697 8.08579C2.35437 8.01193 2.42198 7.95323 2.50177 7.91667L17.5018 2.5Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_11208_70595">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
          {sending ? 'Distributing...' : 'Distribute rewards'}
        </button>
      </header>

      <div className="rd-stats">
        <div className="card stat">
          <div className="label">Total Prize Pool</div>
          <div className="numbers">
            <div className="value">{reward?.data?.stats.total_prize_pool}</div>
            <div className="stat-icon prize">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.3245 9.08333C8.43281 8.59167 7.82448 8.08333 7.82448 7.29167C7.82448 6.38333 8.66615 5.75 10.0745 5.75C11.5578 5.75 12.1078 6.45833 12.1578 7.5H13.9995C13.9411 6.06667 13.0661 4.75 11.3245 4.325V2.5H8.82448V4.3C7.20781 4.65 5.90781 5.7 5.90781 7.30833C5.90781 9.23333 7.49948 10.1917 9.82448 10.75C11.9078 11.25 12.3245 11.9833 12.3245 12.7583C12.3245 13.3333 11.9161 14.25 10.0745 14.25C8.35781 14.25 7.68281 13.4833 7.59115 12.5H5.75781C5.85781 14.325 7.22448 15.35 8.82448 15.6917V17.5H11.3245V15.7083C12.9495 15.4 14.2411 14.4583 14.2411 12.75C14.2411 10.3833 12.2161 9.575 10.3245 9.08333Z"
                  fill="#3A711A"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="card stat">
          <div className="label">Total Winners</div>
          <div className="numbers">
            <div className="value">{reward?.data?.stats.total_winners}</div>
            <div className="stat-icon winners">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_11208_70664)">
                  <path
                    d="M6.66406 17.5H13.3307"
                    stroke="#4593ED"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10 14.167V17.5003"
                    stroke="#4593ED"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M5.83594 3.33301H14.1693"
                    stroke="#4593ED"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.1693 3.33301V9.99967C14.1693 11.1047 13.7303 12.1646 12.9489 12.946C12.1675 13.7274 11.1077 14.1663 10.0026 14.1663C8.89754 14.1663 7.83773 13.7274 7.05633 12.946C6.27492 12.1646 5.83594 11.1047 5.83594 9.99967V3.33301"
                    stroke="#4593ED"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4.16667 9.16634C5.08714 9.16634 5.83333 8.42015 5.83333 7.49967C5.83333 6.5792 5.08714 5.83301 4.16667 5.83301C3.24619 5.83301 2.5 6.5792 2.5 7.49967C2.5 8.42015 3.24619 9.16634 4.16667 9.16634Z"
                    stroke="#4593ED"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.8307 9.16634C16.7512 9.16634 17.4974 8.42015 17.4974 7.49967C17.4974 6.5792 16.7512 5.83301 15.8307 5.83301C14.9103 5.83301 14.1641 6.5792 14.1641 7.49967C14.1641 8.42015 14.9103 9.16634 15.8307 9.16634Z"
                    stroke="#4593ED"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_11208_70664">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>

        <div className="card stat">
          <div className="label">Distributed</div>
          <div className="numbers">
            <div className="value">{reward?.data?.stats.distributed}</div>
            <div className="stat-icon distributed">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_11208_70644)">
                  <path
                    d="M8.33594 11.6667L17.5026 2.5"
                    stroke="#8C4A60"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.5018 2.5L12.0851 17.5C12.0485 17.5798 11.9898 17.6474 11.916 17.6948C11.8421 17.7422 11.7562 17.7674 11.6684 17.7674C11.5807 17.7674 11.4948 17.7422 11.4209 17.6948C11.347 17.6474 11.2883 17.5798 11.2518 17.5L8.3351 11.6667L2.50177 8.75C2.42198 8.71344 2.35437 8.65474 2.30697 8.58088C2.25957 8.50701 2.23438 8.4211 2.23438 8.33333C2.23437 8.24557 2.25957 8.15965 2.30697 8.08579C2.35437 8.01193 2.42198 7.95323 2.50177 7.91667L17.5018 2.5Z"
                    stroke="#8C4A60"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_11208_70644">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>

        <div className="card stat">
          <div className="label">Pending</div>
          <div className="numbers">
            <div className="value">{reward?.data?.stats.pending}</div>
            <div className="stat-icon pending">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.5 7H11V13L16.2 16.2L17 14.9L12.5 12.2V7Z"
                  fill="#73777F"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div className="rd-table">
        <div className="rd-table-head">
          <div className="col rank">Rank</div>
          <div className="col user">User</div>
          <div className="col points">Points</div>
          <div className="col reward">Reward</div>
          <div className="col wallet">User ID</div>
          <div className="col distributedAt">Distributed At</div>
          <div className="col action">Action</div>
        </div>

        <div className="rd-table-body">
          {items.map((it) => (
            <RewardRow key={it.id} item={it} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default RewardDistribution;
